var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToyota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.403,
    height: 44.355,
    viewBox: "0 0 66.403 44.355",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#ccc}.cls-2{fill:#8c8c8c}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "toyota"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_398",
    d: "M33.2 85C14.864 85 0 94.929 0 107.178s14.864 22.178 33.2 22.178 33.2-9.929 33.2-22.178S51.538 85 33.2 85zm16.665 8.684a1.785 1.785 0 0 1-.005 2.886 21.215 21.215 0 0 1-6.954 3 16.441 16.441 0 0 0-.2-.675c-1.468-4.768-4.189-8.286-7.437-9.349 7.331.346 12.377 2.495 14.598 4.138zm-22.371 11.582a51.162 51.162 0 0 0 11.414 0q.06.86.061 1.769c0 7.777-3.472 12.937-5.768 12.937s-5.769-5.16-5.769-12.937q0-.908.062-1.769zm10.563-4.8a41.68 41.68 0 0 1-4.855.277q-.854 0-1.67-.032h-.013a40.315 40.315 0 0 1-3.173-.243c1.185-3.981 3.292-6.368 4.854-6.368s3.671 2.387 4.857 6.366zm-21.516-6.8a24.332 24.332 0 0 1 9.923-3.63l.25-.041a39.651 39.651 0 0 1 4.417-.453c-3.4 1.113-6.221 4.914-7.634 10.023a21.069 21.069 0 0 1-6.961-3.013 1.785 1.785 0 0 1 .005-2.884zM35.212 125.1c-.112.007-.224.011-.337.015q-.83.034-1.67.033c-15.332 0-28.284-8.228-28.284-17.969 0-3.761 1.929-7.295 5.181-10.216 1.156 3.228 5.991 6.009 12.527 7.488q-.112 1.266-.112 2.585c0 9.845 4.785 17.826 10.687 17.826s10.686-7.981 10.686-17.826q0-1.317-.112-2.585c6.536-1.479 11.371-4.26 12.527-7.488 3.251 2.922 5.181 6.456 5.181 10.216-.002 9.311-11.839 17.24-26.274 17.921zm7.5-26.206c.06.227.126.453.2.675-.068-.228-.133-.454-.203-.676z",
    className: "cls-1",
    "data-name": "Trazado 398",
    transform: "translate(0 -85)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_175",
    "data-name": "Grupo 175",
    transform: "translate(13.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_399",
    d: "M105.646 130.083a21.071 21.071 0 0 0 6.961 3.013c-5.66-.227-8.688-1.874-9.646-2.787a2.043 2.043 0 0 1 .356-3.111c2.223-1.633 4.866-2.623 12.507-3.671l-.25.041a24.336 24.336 0 0 0-9.923 3.63 1.785 1.785 0 0 0-.005 2.885z",
    className: "cls-2",
    "data-name": "Trazado 399",
    transform: "translate(-102.391 -118.529)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_400",
    d: "M244.792 85q-.84 0-1.67.028c17.56.581 31.532 10.275 31.532 22.15s-13.971 21.569-31.532 22.15q.83.027 1.67.028c18.336 0 33.2-9.929 33.2-22.178S263.129 85 244.792 85z",
    className: "cls-2",
    "data-name": "Trazado 400",
    transform: "translate(-224.87 -85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_401",
    d: "M255.367 234.965q.112 1.266.112 2.585c0 9.845-4.785 17.826-10.686 17.826a6.556 6.556 0 0 1-1.67-.218c5.108-1.337 8.9-6.041 8.9-14.938l.12-2.7c-.006-1.469 1.771-2.305 3.224-2.555z",
    className: "cls-2",
    "data-name": "Trazado 401",
    transform: "translate(-224.871 -215.515)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_402",
    d: "M251.808 128.553a2.105 2.105 0 0 1-.324.093 3.254 3.254 0 0 1-3.655-1.97c-1.69-4.152-4.829-7.175-7.8-8.147a9.81 9.81 0 0 1 4.142 0c3.248 1.063 5.968 4.581 7.437 9.349.063.227.128.453.2.675z",
    className: "cls-2",
    "data-name": "Trazado 402",
    transform: "translate(-222.181 -113.985)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyota);
export default __webpack_public_path__ + "static/media/toyota.a4e18c620796b8af0dfa76c877767c21.svg";
export { ForwardRef as ReactComponent };